// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#create-btn {
  color: white !important;
}

.padding-header {
  padding-left: 100px;
  padding-right: 100px;
}

.header-color {
  background-color: white;
  border: 1px solid #dadce0;
}

.header-body-margin {
  margin-top: 32px;
}

.header-text {
  height: 76px;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0.18px;
  line-height: 28px;
  padding-top: 24px;
  padding-bottom: 24px;
}

.body-content {
  margin-left: 100px;
  margin-right: 100px;
  margin-top: 32px;
  margin-bottom: 32px;
}

.emptySearchHeight {
  height: 86px;
}

.emptySearchText {
  color: #151515;
  font-family: Roboto;
  font-size: 25px;
  font-weight: 300;
  letter-spacing: 0.12px;
  line-height: 19px;
  text-align: center;
}

.emptySearchPrimarySpacing {
  padding-top: 24px;
}

.searchBar {
  padding-left: auto;
  padding-right: auto;
}

.search {
  height: 48px;
  width: 396px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
}

.addIcon {
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/css/components/listAndCreate.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,YAAY;AACd","sourcesContent":["#create-btn {\n  color: white !important;\n}\n\n.padding-header {\n  padding-left: 100px;\n  padding-right: 100px;\n}\n\n.header-color {\n  background-color: white;\n  border: 1px solid #dadce0;\n}\n\n.header-body-margin {\n  margin-top: 32px;\n}\n\n.header-text {\n  height: 76px;\n  color: rgba(0, 0, 0, 0.87);\n  font-family: Roboto;\n  font-size: 24px;\n  font-weight: 400;\n  letter-spacing: 0.18px;\n  line-height: 28px;\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n\n.body-content {\n  margin-left: 100px;\n  margin-right: 100px;\n  margin-top: 32px;\n  margin-bottom: 32px;\n}\n\n.emptySearchHeight {\n  height: 86px;\n}\n\n.emptySearchText {\n  color: #151515;\n  font-family: Roboto;\n  font-size: 25px;\n  font-weight: 300;\n  letter-spacing: 0.12px;\n  line-height: 19px;\n  text-align: center;\n}\n\n.emptySearchPrimarySpacing {\n  padding-top: 24px;\n}\n\n.searchBar {\n  padding-left: auto;\n  padding-right: auto;\n}\n\n.search {\n  height: 48px;\n  width: 396px;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);\n}\n\n.addIcon {\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
